import React from "react";
import { Outlet } from "react-router-dom";
// import Header from "./header/header";
import SideMenu from "./SideMenu/SideMenu";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "./Header/Header";

const HomeLayout = ({ refresh }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const handleReload = (reload) => {
    setIsLoading(reload);
  };

  return (
    <>
      <SideMenu></SideMenu>
      {/* <Header refreshHeader={refresh} reload={handleReload}></Header> */}
      <Header></Header>
      <div className="layout-screen">
        {navigator.onLine ? null : <div className="no-internet-bar"> {t("noInternetConnection")} </div>}

        <Outlet></Outlet>
      </div>
    </>
  );
};

export default HomeLayout;
